import React, { PureComponent } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import classNames from 'classnames';
import { findDOMNode } from 'react-dom';
import { Button } from 'legacy/components/Button';
import { Input } from 'legacy/components/Input';
import { AlertIcon } from '@hc/component-lib/hclib/assets/inline-svgs';

import { dollarsFormatter } from 'legacy/utils/formatters';
import { strToInt } from 'legacy/utils/strings';

import { PropertyExplorerValue as theme } from 'legacy/css-modules';

const EMPTY_PLACEHOLDER = '$';
class AvmSelectorUserEntered extends PureComponent {
  state = {
    value: ''
  };

  input = React.createRef();

  componentWillMount() {
    const { value } = this.props;
    this.setState({
      value: value ? dollarsFormatter(value) : EMPTY_PLACEHOLDER,
      valueInt: value || 0,
      showWarning: this.determineShowWarning(value)
    });
  }

  determineShowWarning = (value) => {
    const { referenceAvm = {} } = this.props;
    const min = referenceAvm.minVal;
    const max = referenceAvm.maxVal;
    return (
      min !== undefined &&
      max !== undefined &&
      value &&
      (value < min || value > max)
    );
  };

  determineDisabled = () => {
    const { valueInt } = this.state;
    const { isSelected, value: valueInitial } = this.props;
    return valueInitial === valueInt && isSelected;
  };

  handleChange = (inputVal) => {
    const value =
      parseInt(
        inputVal.replace(/\D/g, '').slice(0, this.props.maxLength || 10)
      ) || '';
    this.setState({
      showWarning: this.determineShowWarning(value),
      valueInt: value || 0,
      value
    });
  };

  handleBlur = () => {
    this.setState({
      value: this.state.value
        ? dollarsFormatter(this.state.value)
        : EMPTY_PLACEHOLDER
    });
  };

  handleFocus = (e) => {
    setTimeout(() => {
      // NOTE: This adjusts the cursor position to account for characters removed from formatting ($ ,)
      const input = findDOMNode(this.input.current);
      let selectionAfterFormat = input.selectionStart;
      let selectionStart = input.selectionStart - 1;
      let selectionEnd = input.selectionEnd - 1;
      let i = 1;
      while (i < selectionAfterFormat) {
        if (isNaN(input.value[i])) {
          selectionStart--;
          selectionEnd--;
        }
        i++;
      }
      const value = strToInt(this.state.value) || '';
      this.setState({
        value
      });
      input.setSelectionRange(selectionStart, selectionEnd);
    }, 0);
  };

  handleSelect = () => {
    const { handleSelect } = this.props;
    const { valueInt } = this.state;
    handleSelect(valueInt);
  };

  render() {
    const { label, buttonText, dataHcNames, warningText } = this.props;

    const { value, showWarning } = this.state;
    return (
      <div className={theme['avm-selection-item']}>
        <div className={theme.avmWarning}>
          <ReactCSSTransitionGroup
            transitionName="fadeInDownFadeOut"
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}
            transitionEnter
            transitionLeave
          >
            {showWarning && <AlertIcon key="avmWarningIcon" />}
          </ReactCSSTransitionGroup>
        </div>
        <span data-hc-name={dataHcNames.label} className={theme['avm-label']}>
          {label}
        </span>
        <div data-hc-name={dataHcNames.input}>
          <Input
            theme={theme}
            inputRef={this.input}
            value={value.toString()}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
          />
        </div>
        <ReactCSSTransitionGroup
          transitionName="fadeInFadeOut"
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}
          transitionEnter
          transitionLeave
        >
          {showWarning && (
            <div
              className={classNames(theme.avmWarningText, theme['avm-subtext'])}
            >
              {warningText}
            </div>
          )}
        </ReactCSSTransitionGroup>
        <div className={theme['avm-button-wrapper']}>
          <Button
            dataHcName={dataHcNames.button}
            className={theme['avm-button']}
            onClick={this.handleSelect}
            disabled={this.determineDisabled()}
            mini
          >
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}

export default AvmSelectorUserEntered;
